{
  "schemaVersion": 1,
  "slug": "github",
  "name": "GitHub",
  "description": "Give agents repository tools or let people work with an agent from GitHub issues and pull requests.",
  "categories": [
    "developer"
  ],
  "featured": true,
  "branding": {
    "logoUrl": "/brands/apps/github.svg",
    "darkLogoUrl": "/brands/apps/github-dark.svg"
  },
  "urlPatterns": [
    "https://api.githubcopilot.com/mcp/*",
    "https://github.com/*"
  ],
  "methods": [
    {
      "key": "managed",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "platform_shared"
      ],
      "whenToUse": "Connect your GitHub account for durable MCP, shell Git, gh, and repository access.",
      "defaults": {
        "serverUrl": "https://api.githubcopilot.com/mcp/"
      },
      "guidanceMd": "Authorize Paperclip, then choose selected repositories in GitHub. You can edit repository access later from GitHub's installation settings.",
      "riskTier": "S3",
      "label": "Use this connection as an agent tool",
      "purpose": "tool",
      "oauthStrategy": "paperclip_cloud_connector",
      "connectorProfile": "github.code",
      "grantKinds": [
        "user",
        "agent"
      ],
      "warnings": [
        "Shell Git and gh receive this identity for the run and are not constrained by per-tool Ask-first controls."
      ],
      "requiredResourceFilters": [
        "organization",
        "repository"
      ]
    },
    {
      "key": "mcp-key",
      "transport": "mcp_remote",
      "auth": "api_key",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Use the provider-hosted connection for the quickest setup.",
      "defaults": {
        "serverUrl": "https://api.githubcopilot.com/mcp/"
      },
      "guidanceMd": "Create a fine-grained token limited to the repositories agents should use.",
      "riskTier": "S3",
      "label": "Personal access token (advanced)",
      "purpose": "tool",
      "credentialFields": [
        {
          "key": "authorization",
          "label": "GitHub token",
          "type": "password",
          "required": true,
          "placeholder": "github_pat_...",
          "secret": true
        }
      ],
      "keyPlacement": {
        "location": "header",
        "name": "Authorization",
        "prefix": "Bearer "
      },
      "requiredResourceFilters": [
        "organization",
        "repository"
      ]
    },
    {
      "key": "chat-agent",
      "label": "Chat with an agent",
      "purpose": "channel",
      "provider": "github",
      "transport": "chat_sdk",
      "auth": "api_key",
      "ownershipModes": [
        "customer"
      ],
      "whenToUse": "Let people in GitHub start and continue work with one Paperclip agent.",
      "credentialFields": [
        {
          "key": "appId",
          "label": "GitHub App ID",
          "type": "text",
          "required": true,
          "placeholder": "123456",
          "secret": false
        },
        {
          "key": "privateKey",
          "label": "Private key (PEM)",
          "type": "textarea",
          "required": true,
          "placeholder": "-----BEGIN RSA PRIVATE KEY-----",
          "secret": true
        }
      ],
      "guidanceMd": "Generate the webhook secret in Paperclip, then create one private GitHub App with active SSL-verified webhooks, Issues and Pull requests read/write permission, and the selectable issue_comment and pull_request_review_comment events. GitHub sends installation and installation_repositories automatically. Install the App only on repositories where people may mention the agent.",
      "consoleLinks": {
        "register": "https://github.com/settings/apps/new",
        "docs": "https://docs.github.com/en/apps/creating-github-apps/registering-a-github-app/registering-a-github-app"
      },
      "riskTier": "S3",
      "requiredResourceFilters": [
        "organization",
        "repository"
      ]
    }
  ]
}
